export default __webpack_public_path__ + "static/media/sanmat2.e257c4e1.jpg";